import { normalize, denormalize } from 'normalizr';
import { combineEpics, ofType } from 'redux-observable';
import {
  switchMap, catchError, mergeMap, map,
} from 'rxjs/operators';
import api from 'api/index';
import { handleError } from 'base/errors/store/actions';
import * as actionTypes from './actionTypes';
import { globalPermissionSchema, globalPermissionsSchema } from '../../../store/schema';
import {
  fetchAllGlobalPermissionsSuccess, updateGlobalPermissionsuccess,
} from './actions';
import { entitiesFetchSuccess } from '../../../store/entities/actions';
import { getEntities } from '../../../store/entities/selectors';


const fetchAll = (action$) => action$.pipe(
  ofType(actionTypes.FETCH_ALL),
  switchMap(() => api.globalPermissions.fetchAll().pipe(
    map((response) => normalize(response.body, globalPermissionsSchema)),
    mergeMap(({ entities, result }) => [
      entitiesFetchSuccess(entities),
      fetchAllGlobalPermissionsSuccess(result),
    ]),
    catchError((error) => [handleError(error)]),
  )),
);


const updateGlobalPermission = (action$, state$) => action$.pipe(
  ofType(actionTypes.UPDATE),
  switchMap((action) =>
    api.globalPermissions.update(
      denormalize(action.globalPermission, globalPermissionSchema, getEntities(state$.value)),
    )
      .pipe(
        mergeMap((response) => {
          const { entities } = normalize(response.body, globalPermissionSchema);
          return [
            entitiesFetchSuccess(entities),
            updateGlobalPermissionsuccess(action.role.id),
          ];
        }),
        catchError((error) => [handleError(error)]),
      )),
);

export default combineEpics(
  fetchAll,
  updateGlobalPermission,
);
